const FlavorType = {
  DEV: 'DEV',
  PROD: 'PROD',
  VMCProd: 'VMCProd',
  MENTOMINDUSPROD: 'MENTOMINDUSPROD',
  DEMOPROD: 'DEMOPROD',
  MMEDUCATOR: 'MMEDUCATOR',
};

const APP_VERSION = "2.7.0";
const APP_BUILDNUMBER = "192";
const APP_FLAVOR = process.env.NODE_ENV === 'production' ? FlavorType.VMCProd : FlavorType.DEV;

export default { FlavorType, APP_VERSION, APP_BUILDNUMBER, APP_FLAVOR }
